import {
    AfterViewInit, Component, EventEmitter, Output, NgZone, OnInit
} from '@angular/core';
import { IdentificationStepsService } from '../services/identification-steps.service';
import { AuthenticatedUserRepositoryService } from '../services/authenticated-user-repository.service';
import { UnauthenticatedUserRepositoryService } from '../services/unauthenticated-user-repository.service';
import { ClientModel } from '../../shared/models/client.model';
import { OauthService } from '../../shared/services/oauth.service';
import { CookieService } from 'angular2-cookie/core';

@Component({
    selector: 'payment-identification',
    templateUrl: './payment.identification.component.html',
    styleUrls: ['./../payment.component.scss']
})
export class PaymentIdentificationComponent implements
    AfterViewInit,
    OnInit
{
    public wasInputtedEmail = false;
    public wasIdentifiedUser = false;
    public recoveringPassword = false;
    public existentEmail = false;
    public creatingClient = false;
    public loading = false;
    public name1: string;
    public email: string;
    @Output() ready: EventEmitter<ClientModel> = new EventEmitter();
    @Output() activated: EventEmitter<null> = new EventEmitter();

    constructor(
        protected identificationStepsService: IdentificationStepsService,
        protected authenticatedUserRepository: AuthenticatedUserRepositoryService,
        protected unauthenticatedUserRepository: UnauthenticatedUserRepositoryService,
        protected oauthService: OauthService,
        private zone: NgZone,
        private cookieService: CookieService
    ) {
        this.oauthService.requestingToken$.subscribe(() => {
            this.zone.run(() => this.loading = true);
        });
        this.oauthService.loadingAuthenticatedUser$.subscribe(() => {
            this.zone.run(() => this.loading = true);
        });
        this.oauthService.tokenRefused$.subscribe(() => {
            this.zone.run(() => this.loading = false);
        });
        this.oauthService.loadedAuthenticatedUser$.subscribe((user) => {
            this.zone.run(() => {
                this.loading = false;
                this.name1 = user.name1;
                this.email = user.email;
            });
        });
        this.authenticatedUserRepository.changedUser$.subscribe(user => {
            this.zone.run(() => {
                this.wasInputtedEmail = this.identificationStepsService.wasInputtedEmail();
                this.wasIdentifiedUser = this.identificationStepsService.wasIdentifiedUser();
                this.existentEmail = this.identificationStepsService.existentEmail();
                if (user != null) {
                    this.name1 = user.name1;
                    this.email = user.email;
                    this.ready.emit(user);
                }
            });
        });
        this.unauthenticatedUserRepository.emailChanged$.subscribe(email => {
            this.zone.run(() => {
                this.email = email;
                this.wasInputtedEmail = this.identificationStepsService.wasInputtedEmail();
                this.wasIdentifiedUser = this.identificationStepsService.wasIdentifiedUser();
                this.existentEmail = this.identificationStepsService.existentEmail();
            });
        });
    }

    ngOnInit() {
        if (undefined !== this.cookieService.get('jns_sp')) {
            const name = this.cookieService.get('jns_nm');
            const names = this.cookieService.get('jns_nm').split(' ');
            const email = this.cookieService.get('jns_eml');
            const provider = this.cookieService.get('jns_sp');
            const id = this.cookieService.get('jns_sid');
            const socialUser = {
                email: email,
                image: '',
                name: name,
                provider: provider,
                token: '',
                uid: id
            };

            this.unauthenticatedUserRepository.setSocialNetwork(provider);
            this.unauthenticatedUserRepository.setSocialUser(socialUser);
            this.unauthenticatedUserRepository.setName1(names.shift());
            this.unauthenticatedUserRepository.setName2(names.join(' '));
            this.unauthenticatedUserRepository.setSocialUid(id);
            this.unauthenticatedUserRepository.setEmailExists(false);
            this.unauthenticatedUserRepository.setEmail(email);
        }
    }
    ngAfterViewInit() {
        this.activated.emit(null);
    }

    /**
     * creatingClient event listener.
     **/
    public onCreatingClient() {
        this.creatingClient = true;
        this.loading = true;
    }
    /**
     * createdClient event listener.
     **/
    public onCreatedClient() {
        this.creatingClient = false;
        this.loading = false;
    }
    /**
     * failedCreateClient event listener.
     **/
    public onFailedCreateClient() {
        this.loading = false;
    }
    /**
     * resetedEmail event listener.
     **/
    public onResetedEmail() {
        this.email = null;
        this.wasInputtedEmail = this.identificationStepsService.wasInputtedEmail();
        this.wasIdentifiedUser = this.identificationStepsService.wasIdentifiedUser();
        this.existentEmail = this.identificationStepsService.existentEmail();
        this.creatingClient = false;
        this.recoveringPassword = false;
    }

    /**
     * requestingPasswordRecovery event listener.
     **/
    public onRequestingPasswordRecovery() {
        this.recoveringPassword = true;
    }
    /**
     * savedNewPassword event listener.
     **/
    public onSavedNewPassword() {
        this.recoveringPassword = false;
        this.loading = false;
    }
    /**
     * validatedToken event listener.
     **/
    public onValidatedToken() {
        this.recoveringPassword = false;
        this.loading = false;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/payment/identification/payment.identification.component.ts